// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-6eacaffe] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.list-item__wrapper[data-v-6eacaffe] {
  display: flex;
  position: relative;
  width: 100%;
}
.list-item__wrapper--active .list-item[data-v-6eacaffe],
.list-item__wrapper.active .list-item[data-v-6eacaffe] {
  background-color: var(--color-primary-element);
}
.list-item__wrapper--active .list-item[data-v-6eacaffe]:hover,
.list-item__wrapper--active .list-item[data-v-6eacaffe]:focus-within,
.list-item__wrapper--active .list-item[data-v-6eacaffe]:has(:focus-visible),
.list-item__wrapper--active .list-item[data-v-6eacaffe]:has(:active),
.list-item__wrapper.active .list-item[data-v-6eacaffe]:hover,
.list-item__wrapper.active .list-item[data-v-6eacaffe]:focus-within,
.list-item__wrapper.active .list-item[data-v-6eacaffe]:has(:focus-visible),
.list-item__wrapper.active .list-item[data-v-6eacaffe]:has(:active) {
  background-color: var(--color-primary-element-hover);
}
.list-item__wrapper--active .list-item-content__name[data-v-6eacaffe],
.list-item__wrapper--active .list-item-content__subname[data-v-6eacaffe],
.list-item__wrapper--active .list-item-content__details[data-v-6eacaffe],
.list-item__wrapper--active .list-item-details__details[data-v-6eacaffe],
.list-item__wrapper.active .list-item-content__name[data-v-6eacaffe],
.list-item__wrapper.active .list-item-content__subname[data-v-6eacaffe],
.list-item__wrapper.active .list-item-content__details[data-v-6eacaffe],
.list-item__wrapper.active .list-item-details__details[data-v-6eacaffe] {
  color: var(--color-primary-element-text) !important;
}
.list-item__wrapper .list-item-content__name[data-v-6eacaffe],
.list-item__wrapper .list-item-content__subname[data-v-6eacaffe],
.list-item__wrapper .list-item-content__details[data-v-6eacaffe],
.list-item__wrapper .list-item-details__details[data-v-6eacaffe] {
  white-space: nowrap;
  margin: 0 auto 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-item-content__name[data-v-6eacaffe] {
  min-width: 100px;
  max-width: 300px;
  flex: 1 1 10%;
  font-weight: 500;
}
.list-item-content__subname[data-v-6eacaffe] {
  flex: 1 0;
  min-width: 0;
  color: var(--color-text-maxcontrast);
}
.list-item-content__subname--bold[data-v-6eacaffe] {
  font-weight: 500;
}
.list-item[data-v-6eacaffe] {
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: 8px 10px;
  margin: 4px;
  width: calc(100% - 8px);
  border-radius: 32px;
  cursor: pointer;
  transition: background-color var(--animation-quick) ease-in-out;
  list-style: none;
}
.list-item[data-v-6eacaffe]:hover,
.list-item[data-v-6eacaffe]:focus-within,
.list-item[data-v-6eacaffe]:has(:active),
.list-item[data-v-6eacaffe]:has(:focus-visible) {
  background-color: var(--color-background-hover);
}
.list-item[data-v-6eacaffe]:has(.list-item__anchor:focus-visible) {
  outline: 2px solid var(--color-main-text);
  box-shadow: 0 0 0 4px var(--color-main-background);
}
.list-item--compact[data-v-6eacaffe] {
  padding: 4px 10px;
}
.list-item--compact .list-item__anchor .line-one[data-v-6eacaffe],
.list-item--compact .list-item__anchor .line-two[data-v-6eacaffe] {
  margin-block: -4px;
}
.list-item .list-item-content__details[data-v-6eacaffe] {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
}
.list-item--one-line[data-v-6eacaffe] {
  padding: 0 9px;
  margin: 2px;
}
.list-item--one-line .list-item-content__main[data-v-6eacaffe] {
  display: flex;
  justify-content: start;
  gap: 12px;
  min-width: 0;
}
.list-item--one-line .list-item-content__details[data-v-6eacaffe] {
  flex-direction: row;
  align-items: unset;
  justify-content: end;
}
.list-item__anchor[data-v-6eacaffe] {
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  height: var(--default-clickable-area);
  min-width: 0;
}
.list-item__anchor[data-v-6eacaffe]:focus-visible {
  outline: none;
}
.list-item-content[data-v-6eacaffe] {
  display: flex;
  flex: 1 0;
  justify-content: space-between;
  padding-left: 8px;
  min-width: 0;
}
.list-item-content__main[data-v-6eacaffe] {
  flex: 1 0;
  width: 0;
  margin: auto 0;
}
.list-item-content__main--oneline[data-v-6eacaffe] {
  display: flex;
}
.list-item-content__actions[data-v-6eacaffe] {
  flex: 0 0 auto;
  align-self: center;
  justify-content: center;
  margin-left: 4px;
}
.list-item-details__details[data-v-6eacaffe] {
  color: var(--color-text-maxcontrast);
  margin: 0 9px !important;
  font-weight: 400;
}
.list-item-details__extra[data-v-6eacaffe] {
  margin: 2px 4px 0;
  display: flex;
  align-items: center;
}
.list-item-details__indicator[data-v-6eacaffe] {
  margin: 0 5px;
}
.list-item__extra[data-v-6eacaffe] {
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcListItem-BIFTbr17.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,8CAA8C;AAChD;AACA;;;;;;;;EAQE,oDAAoD;AACtD;AACA;;;;;;;;EAQE,mDAAmD;AACrD;AACA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+DAA+D;EAC/D,gBAAgB;AAClB;AACA;;;;EAIE,+CAA+C;AACjD;AACA;EACE,yCAAyC;EACzC,kDAAkD;AACpD;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-6eacaffe] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.list-item__wrapper[data-v-6eacaffe] {\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n.list-item__wrapper--active .list-item[data-v-6eacaffe],\n.list-item__wrapper.active .list-item[data-v-6eacaffe] {\n  background-color: var(--color-primary-element);\n}\n.list-item__wrapper--active .list-item[data-v-6eacaffe]:hover,\n.list-item__wrapper--active .list-item[data-v-6eacaffe]:focus-within,\n.list-item__wrapper--active .list-item[data-v-6eacaffe]:has(:focus-visible),\n.list-item__wrapper--active .list-item[data-v-6eacaffe]:has(:active),\n.list-item__wrapper.active .list-item[data-v-6eacaffe]:hover,\n.list-item__wrapper.active .list-item[data-v-6eacaffe]:focus-within,\n.list-item__wrapper.active .list-item[data-v-6eacaffe]:has(:focus-visible),\n.list-item__wrapper.active .list-item[data-v-6eacaffe]:has(:active) {\n  background-color: var(--color-primary-element-hover);\n}\n.list-item__wrapper--active .list-item-content__name[data-v-6eacaffe],\n.list-item__wrapper--active .list-item-content__subname[data-v-6eacaffe],\n.list-item__wrapper--active .list-item-content__details[data-v-6eacaffe],\n.list-item__wrapper--active .list-item-details__details[data-v-6eacaffe],\n.list-item__wrapper.active .list-item-content__name[data-v-6eacaffe],\n.list-item__wrapper.active .list-item-content__subname[data-v-6eacaffe],\n.list-item__wrapper.active .list-item-content__details[data-v-6eacaffe],\n.list-item__wrapper.active .list-item-details__details[data-v-6eacaffe] {\n  color: var(--color-primary-element-text) !important;\n}\n.list-item__wrapper .list-item-content__name[data-v-6eacaffe],\n.list-item__wrapper .list-item-content__subname[data-v-6eacaffe],\n.list-item__wrapper .list-item-content__details[data-v-6eacaffe],\n.list-item__wrapper .list-item-details__details[data-v-6eacaffe] {\n  white-space: nowrap;\n  margin: 0 auto 0 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.list-item-content__name[data-v-6eacaffe] {\n  min-width: 100px;\n  max-width: 300px;\n  flex: 1 1 10%;\n  font-weight: 500;\n}\n.list-item-content__subname[data-v-6eacaffe] {\n  flex: 1 0;\n  min-width: 0;\n  color: var(--color-text-maxcontrast);\n}\n.list-item-content__subname--bold[data-v-6eacaffe] {\n  font-weight: 500;\n}\n.list-item[data-v-6eacaffe] {\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  margin: 4px;\n  width: calc(100% - 8px);\n  border-radius: 32px;\n  cursor: pointer;\n  transition: background-color var(--animation-quick) ease-in-out;\n  list-style: none;\n}\n.list-item[data-v-6eacaffe]:hover,\n.list-item[data-v-6eacaffe]:focus-within,\n.list-item[data-v-6eacaffe]:has(:active),\n.list-item[data-v-6eacaffe]:has(:focus-visible) {\n  background-color: var(--color-background-hover);\n}\n.list-item[data-v-6eacaffe]:has(.list-item__anchor:focus-visible) {\n  outline: 2px solid var(--color-main-text);\n  box-shadow: 0 0 0 4px var(--color-main-background);\n}\n.list-item--compact[data-v-6eacaffe] {\n  padding: 4px 10px;\n}\n.list-item--compact .list-item__anchor .line-one[data-v-6eacaffe],\n.list-item--compact .list-item__anchor .line-two[data-v-6eacaffe] {\n  margin-block: -4px;\n}\n.list-item .list-item-content__details[data-v-6eacaffe] {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: end;\n}\n.list-item--one-line[data-v-6eacaffe] {\n  padding: 0 9px;\n  margin: 2px;\n}\n.list-item--one-line .list-item-content__main[data-v-6eacaffe] {\n  display: flex;\n  justify-content: start;\n  gap: 12px;\n  min-width: 0;\n}\n.list-item--one-line .list-item-content__details[data-v-6eacaffe] {\n  flex-direction: row;\n  align-items: unset;\n  justify-content: end;\n}\n.list-item__anchor[data-v-6eacaffe] {\n  display: flex;\n  flex: 1 0 auto;\n  align-items: center;\n  height: var(--default-clickable-area);\n  min-width: 0;\n}\n.list-item__anchor[data-v-6eacaffe]:focus-visible {\n  outline: none;\n}\n.list-item-content[data-v-6eacaffe] {\n  display: flex;\n  flex: 1 0;\n  justify-content: space-between;\n  padding-left: 8px;\n  min-width: 0;\n}\n.list-item-content__main[data-v-6eacaffe] {\n  flex: 1 0;\n  width: 0;\n  margin: auto 0;\n}\n.list-item-content__main--oneline[data-v-6eacaffe] {\n  display: flex;\n}\n.list-item-content__actions[data-v-6eacaffe] {\n  flex: 0 0 auto;\n  align-self: center;\n  justify-content: center;\n  margin-left: 4px;\n}\n.list-item-details__details[data-v-6eacaffe] {\n  color: var(--color-text-maxcontrast);\n  margin: 0 9px !important;\n  font-weight: 400;\n}\n.list-item-details__extra[data-v-6eacaffe] {\n  margin: 2px 4px 0;\n  display: flex;\n  align-items: center;\n}\n.list-item-details__indicator[data-v-6eacaffe] {\n  margin: 0 5px;\n}\n.list-item__extra[data-v-6eacaffe] {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
